import React from 'react';
import ReactDOM from 'react-dom';
import { BodyText, Button, FlexRow, Grid, ModalWindow } from 'ui-toolkit';
import { IDisbursementFormData } from 'types/order/escrow/IDisbursementFormData';
import { ModalTarget } from '../../../lineItem/ModalTarget.Constant';

interface IDeleteConfirmationModalProps {
  data: IDisbursementFormData;
  nameKey?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteConfirmationModal: React.FC<IDeleteConfirmationModalProps> = ({
  data,
  nameKey,
  onConfirm,
  onCancel,
}) => {
  return ReactDOM.createPortal(
    <ModalWindow mode={'transition'}>
      <Grid>
        <BodyText>
          Are you sure you wish to delete the disbursement
          {nameKey && data[nameKey] && ` to ${data[nameKey]}`}?
        </BodyText>
        <FlexRow justifyContent={'center'}>
          <Button intent={'danger'} onClick={onConfirm}>
            Yes Delete
          </Button>
          <Button intent={'secondary'} onClick={onCancel}>
            No
          </Button>
        </FlexRow>
      </Grid>
    </ModalWindow>,
    document.getElementById(ModalTarget)!
  );
};
